<script lang="ts">
  import { _ } from 'svelte-i18n';
  import { fly, fade } from 'svelte/transition';
  import { flip } from 'svelte/animate';
  import { notificationList, notifications } from '$lib/stores/notifications';

  // The icons are drawn here rather than fetched.
  //
  // These two were the app's only Iconify icons, and @iconify/svelte resolves a
  // name by asking api.iconify.design for it at runtime. The CSP allows the API
  // and Cloudflare and nothing else, so all three of Iconify's hosts were
  // refused and the icons never appeared — on the error toast, which is the one
  // component a customer sees precisely when something has already gone wrong.
  //
  // Inline is also what the other 28 components here do, so this is one fewer
  // dependency and one fewer thing to load rather than a second way of doing
  // icons.

  // Filter to only show errors
  $: errorNotifications = $notificationList.filter((n) => n.type === 'error');
</script>

<div class="fixed right-4 top-4 z-50 max-w-md space-y-2">
  {#each errorNotifications as notification (notification.id)}
    <div
      class="flex items-start gap-3 rounded-lg border border-gray-200 bg-gray-100 p-4 text-gray-800 shadow-lg"
      in:fly={{ x: 100, duration: 300 }}
      out:fade={{ duration: 200 }}
      animate:flip={{ duration: 300 }}
    >
      <svg
        class="mt-0.5 h-5 w-5 flex-shrink-0 text-red-600"
        fill="none"
        viewBox="0 0 24 24"
        stroke="currentColor"
        aria-hidden="true"
      >
        <path
          stroke-linecap="round"
          stroke-linejoin="round"
          stroke-width="2"
          d="M12 8v4m0 4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z"
        />
      </svg>
      <p class="flex-1 text-sm">{notification.message}</p>
      <button
        type="button"
        class="ml-2 flex-shrink-0 text-gray-600 transition-opacity hover:opacity-70"
        on:click={() => notifications.remove(notification.id)}
        aria-label={$_('a11y.dismissNotification')}
      >
        <svg
          class="h-5 w-5"
          fill="none"
          viewBox="0 0 24 24"
          stroke="currentColor"
          aria-hidden="true"
        >
          <path
            stroke-linecap="round"
            stroke-linejoin="round"
            stroke-width="2"
            d="M6 18L18 6M6 6l12 12"
          />
        </svg>
      </button>
    </div>
  {/each}
</div>
